module.exports = __webpack_public_path__ + "static/media/dish9.8b3fa95c.jpg";